import React from 'react';

const Hero2 = () => {
  return (
    <div className="hero2">
      <div className="hero2__header">
        <h1>
          Powering Perfect Produce
          <br /> with Lenovo and Intel
        </h1>
      </div>
      <div className="hero2__subhead">
        <p>
          How Perfection Fresh Australia leverages tech from field to fork to stay on the cutting
          edge
        </p>
      </div>
    </div>
  );
};

export default Hero2;
